import { Component, Input } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { RssFeed } from '../../../../data-access/models/rss-feed.model';

@Component({
  selector: 'app-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss'],
  imports: [PipesModule],
  standalone: true,
})
export class NewsCardComponent {
  @Input() data?: RssFeed;

  onShowMore(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    window.open(this.data?.link);
  }
}
